@if (label) {
  <div class="labels-container">
    <div class="text-description c-secondary" [class]="{ 'c-gray': color === colorTypeEnum.GRAY }">{{ label }}</div>
    <div class="value-label {{ color }}">
      @if (type === 'currency') {
        {{ value | customCurrency }}
      } @else {
        {{ value | percent }}
      }
    </div>
  </div>
}

<div class="bar">
  <div class="bar-value {{color}} {{colorClass}}" [style.width.%]="percent" [ngClass]="size"></div>
</div>
